import { Button, Table, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FileExcelOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserDetails } from '../features/auth/authSlice';
import * as XLSX from 'xlsx';
import { AUTH_URL } from '../constants';
import { TfiReload } from 'react-icons/tfi';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import dayjs, { Dayjs } from 'dayjs';
import { IAccount } from '../factory/interfaces';
import { IoMdArrowDropright } from 'react-icons/io';

const { RangePicker } = DatePicker;

// Define EventValue type locally
type EventValue<T> = T | null;

const AccountsTable = () => {
  const dispatch = useDispatch();

  // Variables/states
  const [dateRange, setDateRange] = useState<string[]>(['2024-03-17', '2024-05-20']);
  const momentArray: Moment[] = dateRange.map(date => moment(date));

  // Convert moment array to Dayjs array
  const dayjsArray: Dayjs[] = momentArray.map(date => dayjs(date.toDate()));
  const valueArray: [EventValue<Dayjs>, EventValue<Dayjs>] = [
    dayjsArray[0] || null,
    dayjsArray[1] || null,
  ];

  const user_details = useSelector(selectUserDetails);

  const [accounts, setAccounts] = useState<IAccount[]>();

  // Functions
  const columns = [
    {
      title: 'No.',
      dataIndex: 'count',
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: 'Account number',
      dataIndex: 'account_number',
      key: 'account_number',
    },
    {
      title: 'Client',
      dataIndex: 'client',
      key: 'client',
    },
    {
      title: 'Branch',
      dataIndex: 'branch',
      key: 'branch',
    },
    {
      title: 'Current loan',
      dataIndex: 'current_loan_amount',
      key: 'current_loan_amount',
    },
    {
      title: 'Current savings',
      dataIndex: 'current_savings_amount',
      key: 'current_savings_amount',
    },
  ];

  const exportToExcel = () => {
    const fileName = 'rpms_data.xlsx';
    const table = document.getElementById('rpms-data-table');
    const clonedTable = table?.cloneNode(true) as HTMLTableElement;
    const excludedColumnIndices = [7];
    clonedTable.querySelectorAll('tr').forEach(row => {
      excludedColumnIndices.forEach(index => {
        row.deleteCell(index);
      });
    });

    const worksheet = XLSX.utils.table_to_sheet(clonedTable);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  };

  const getAccounts = async () => {
    const response = await axios.get(`${AUTH_URL}/accounts`, { withCredentials: true });
    if (response.data.success) {
      setAccounts(response.data.accounts);
    }
  };

  useEffect(() => {
    getAccounts();
  }, [dispatch, dateRange]);

  return (
    <>
      {accounts ? (
        <>
          <Row className="justify-content-between align-items-center py-0 g-0">
            <Col className="text-start">
              <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Accounts</h4>
            
            </Col>
            <Col className="text-end py-2">
              <Button className="rounded-0" type="dashed">
                <TfiReload /> <span className="mx-1">Reload</span>
              </Button>
            </Col>
          </Row>

          {accounts && <Table className="rounded-0" id="rpms-data-table" bordered dataSource={accounts} columns={columns} />}
        </>
      ) : (
        <Spin style={{ paddingTop: 100 }} tip="Loading data..." size="large">
          <div className="content" />
        </Spin>
      )}
    </>
  );
};

export default AccountsTable;
